import React from 'react';

const CopyIcon = props => (
  <svg width='13' height='14' viewBox='0 0 13 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M2.72 2.72V0.679999C2.72 0.499652 2.79164 0.326692 2.91917 0.199167C3.04669 0.0716426 3.21965 0 3.4 0H11.56C11.7403 0 11.9133 0.0716426 12.0408 0.199167C12.1683 0.326692 12.24 0.499652 12.24 0.679999V10.2C12.24 10.3803 12.1683 10.5533 12.0408 10.6808C11.9133 10.8083 11.7403 10.88 11.56 10.88H9.51999V12.92C9.51999 13.2953 9.21399 13.6 8.83523 13.6H0.684759C0.595086 13.6005 0.50619 13.5833 0.423179 13.5494C0.340168 13.5155 0.264678 13.4655 0.201048 13.4023C0.137417 13.3391 0.0868991 13.264 0.0523969 13.1812C0.0178946 13.0984 8.79745e-05 13.0097 0 12.92L0.00204001 3.4C0.00204001 3.02464 0.30804 2.72 0.6868 2.72H2.72ZM1.36204 4.08L1.36 12.24H8.15999V4.08H1.36204ZM4.08 2.72H8.71999C9.16182 2.72 9.51999 3.07817 9.51999 3.52V9.51999H10.88V1.36H4.08V2.72Z'
      fill='#868686'
    />
  </svg>
);

export default CopyIcon;
